module.exports = __webpack_public_path__ + "static/media/up_focussed.a3c32ca9.svg";